import type { IconProps } from './../../models/icon';

export function TheatreIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M0.856934 8.2972C0.857086 10.5738 1.62403 12.7841 3.03408 14.5715L7.38456 18.075C8.01226 18.5805 8.90732 18.5805 9.53503 18.075L13.8855 14.5715C15.2956 12.7841 16.0625 10.5738 16.0626 8.2972V2.70862C13.7128 1.49265 11.1056 0.858032 8.45979 0.858032C5.81398 0.858032 3.20677 1.49265 0.856934 2.70862V8.2972Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M3.03408 14.5715C1.62403 12.7841 0.857086 10.5738 0.856934 8.2972V2.70862C3.20677 1.49265 5.81398 0.858032 8.45979 0.858032C11.1056 0.858032 13.7128 1.49265 16.0626 2.70862"
        />
        <path
          fill={secondaryColor}
          d="M13.3544 23.04C12.7545 23.1756 12.131 23.167 11.535 23.0151C10.9391 22.8631 10.3876 22.572 9.92586 22.1657C8.32172 20.7828 7.13384 18.9811 6.49506 16.9617C5.85627 14.9424 5.79176 12.7853 6.30872 10.7314L7.56015 5.7257C10.2781 5.03637 13.1247 5.03265 15.8445 5.71483C18.5643 6.39701 21.0721 7.74377 23.143 9.63427L21.8916 14.6228C21.387 16.6786 20.322 18.5539 18.8146 20.04C17.3074 21.5261 15.4171 22.5646 13.3544 23.04Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M13.3544 23.04C12.7545 23.1756 12.131 23.167 11.535 23.0151C10.939 22.8631 10.3876 22.572 9.92586 22.1657C8.32171 20.7828 7.13385 18.9811 6.49506 16.9617C5.85628 14.9424 5.79175 12.7853 6.30871 10.7314L7.56014 5.72569C10.2781 5.03638 13.1247 5.03264 15.8445 5.71482C18.5643 6.39701 21.0722 7.74378 23.143 9.63426L21.8916 14.6228C21.3871 16.6786 20.322 18.5539 18.8146 20.04C17.3072 21.5261 15.4171 22.5646 13.3544 23.04Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M9.61719 11.1601C9.83344 10.9338 10.1075 10.771 10.4097 10.6894C10.7119 10.6078 11.0307 10.6105 11.3315 10.6972C11.6259 10.7665 11.8967 10.9124 12.1165 11.1201C12.3363 11.3278 12.4972 11.59 12.5829 11.8801"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M16.4058 12.8571C16.6151 12.6322 16.881 12.4676 17.1758 12.3807C17.4705 12.2938 17.7832 12.2876 18.0811 12.363C18.3791 12.4384 18.6511 12.5924 18.8692 12.809C19.0871 13.0256 19.2429 13.2968 19.32 13.5943"
        />
      </g>
    </svg>
  );
}
